var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0539 1.67336C11.2278 1.49951 11.4342 1.3616 11.6613 1.26751C11.8885 1.17343 12.1319 1.125 12.3778 1.125C12.6236 1.125 12.8671 1.17343 13.0942 1.26751C13.3214 1.3616 13.5278 1.49951 13.7016 1.67336C13.8755 1.84721 14.0134 2.0536 14.1075 2.28075C14.2016 2.5079 14.25 2.75135 14.25 2.99722C14.25 3.24308 14.2016 3.48653 14.1075 3.71368C14.0134 3.94083 13.8755 4.14722 13.7016 4.32107L4.76561 13.2571L1.125 14.25L2.11789 10.6094L11.0539 1.67336Z",
    stroke: "#346C84",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.7ae93eca109ef8d8213c8af82e543897.svg";
export { ForwardRef as ReactComponent };